import I18n from '@src/i18n';
import { Col, Row } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

interface IAuditHistoryItemHeaderComponentPropType {
    auditPersonName: string;
    auditWithTitle?: string;
}

export default class AuditHistoryItemHeaderComponent extends React.Component<IAuditHistoryItemHeaderComponentPropType, {}> {
    render(): JSX.Element {
        return (
            <GoEpikHistoryHeader>
                <Row className="goepik-side-padding ">
                    <Col sm={24} md={24} xl={24}>
                        <Row>
                            <Col sm={24} md={24} xl={24}>
                                <h2>
                                    {(!!this.props.auditWithTitle ? this.props.auditWithTitle : I18n.l('history.audits.titles.auditWith'))
                                        + " " + I18n.l('common.with') + " " +
                                        this.props.auditPersonName}</h2>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </GoEpikHistoryHeader>
        );
    }
};

const GoEpikHistoryHeader = styled.div`
    .goepik-history-header-title{
        font-weight:900;
    }
    .goepik-side-padding{
        padding-left: 24px!important;
        padding-right: 24px!important;
    }
    .goepik-text-center{
        text-align: center;
    }
    h2{
        font-size:20px;
        font-weight:bold;
    }
`;

